import { get, isObject } from 'lodash';

/** Exact text of Neutron's `SpotNotReservableError` (yard.errors.ts) — kept in sync by hand. */
const SPOT_NOT_RESERVABLE_MESSAGE = 'Only open spots can be reserved.';

/** Exact text of the `YardTaskError` Neutron raises for a move whose destination spot is gone. */
const DESTINATION_SPOT_NOT_FOUND_MESSAGE = 'Destination spot not found.';

interface ErrorResponseShape {
  response?: {
    status?: number;
    data?: { message?: string };
  };
}

/**
 * Whether a create/update rejection is the backend's refusal to reserve a non-open destination.
 * Matched by exact message rather than trusting any backend error text generally — other failure
 * modes keep showing the existing generic snackbar copy.
 */
export function isSpotNotReservableError(error: unknown): boolean {
  const response = (error as ErrorResponseShape)?.response;

  return response?.status === 400 && response?.data?.message === SPOT_NOT_RESERVABLE_MESSAGE;
}

type ErrorWithResponse = { response: NonNullable<ErrorResponseShape['response']> };

function hasResponse(error: unknown): error is ErrorWithResponse {
  return isObject(error) && isObject(get(error, 'response'));
}

/** Whether a start/complete rejection is the backend's refusal of a move whose destination spot no longer exists. */
export function isDestinationSpotNotFoundError(error: unknown): boolean {
  if (!hasResponse(error)) {
    return false;
  }

  const { response } = error;

  return response.status === 400 && response.data?.message === DESTINATION_SPOT_NOT_FOUND_MESSAGE;
}
